import React, { useEffect, useRef, useState } from 'react'
import Sidebaar from '../Component/Sidebar'
import { Form, FormGroup, Modal } from 'react-bootstrap'
import TitleComp from '../Component/TitleComp'
import axios from 'axios'
import { Base_Url } from '../BaseUrl'
import { Box } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import Iframe from "react-iframe";
import { Bars } from 'react-loader-spinner'
import { ToastContainer, toast } from 'react-toastify'

function Videosection() {
    const [name, setname] = useState("")
    const [youtube_link, setyoutube_link] = useState("")
    const [description, setdescription] = useState("")
    const [image, setimage] = useState("")
    const [data, setdata] = useState([])
    const [videoshow, setVideoShow] = useState(false);
    const [currentVideo, setCurrentVideo] = useState("");
    const [loading, setloading] = useState(false)
    const ImageInputRef = useRef(null);

    let token = localStorage.getItem("token")

    const handleVideoClose = () => {
        setCurrentVideo("");
        setVideoShow(false);
    };



    const handleget = () => {
        axios.get(`${Base_Url}/video_sections`).then((res) => {
            setdata(res.data.data)

        })
    }

    useEffect(() => {
        handleget()
    }, [])

    const handlefile = (e) => {
        e.preventDefault()
        let selectedfile = e.target.files[0]
        setimage(selectedfile)
    }

    const handleclear = () => {
        setname("")
        setdescription("")
        setimage("")
        setyoutube_link("")
        if (ImageInputRef.current) {
            ImageInputRef.current.value = '';
        }
    }



    const handleSubmit = (e) => {
        e.preventDefault()
        setloading(true)
        let formdata = new FormData()
        formdata.append("name", name)
        formdata.append("image", image)
        formdata.append("description", description)
        formdata.append("youtube_link", youtube_link)
        axios.post(`${Base_Url}/video_sections`, formdata, { headers }).then((res) => {
            console.log(res)

            if (res.data.error == 0) {
                setloading(false)
                toast.success("Data Submit Successfully")
                handleget()
                handleclear()
            }
        }).finally((err) => {
            setloading(false)
        })
    }
    const getRowId = (row) => row._id

    let headers = {
        Authorization: `Bearer ${token}`
    }

    const columns = [
        {
            field: "image",
            headerName: "Image",
            flex: 1,
            renderCell: (params) => {
                return (
                    <img src={`${Base_Url}/${params.row.image}`} style={{ width: "45px", height: "45px", borderRadius: "50%" }} className='img-fluid' alt="" />
                )
            }
        },
        {
            field: "name",
            headerName: "Name",
            flex: 1,
        },
        {
            field: "description",
            headerName: "Description",
            flex: 1,
        },
        {
            field: "youtube_link",
            headerName: "youtube_link",
            flex: 5,
        },
        {
            field: "watchbutton",
            headerName: "Watch",
            flex: 1,
            renderCell: (params) => {
                let item = params.row.youtube_link
                return (
                    <button
                        data-url={`${item}?ecver=1&iv_load_policy=3&controls=0&rel=0&showinfo=0&yt:stretch=16:9&autohide=1&color=red&width=560&width=560`}
                        className="btn w-100 bg-blue text-white rounded-pill"
                        style={{ fontSize: "12px" }}
                        onClick={() => handleVideoShow(item)}
                    >
                        Watch Video
                    </button>
                )
            }
        },
        {
            field: "delete",
            headerName: "Delete",
            flex: 1,
            renderCell: (params) => {
                let paramsid = params.row._id
                return (
                    <button className='btn bg-dark text-white' onClick={(e) => handledelete(e, paramsid)} style={{ fontSize: "12px" }}><i class="fa-solid fa-trash"></i></button>
                )
            }
        }
    ]


    const handledelete = (e, id) => {
        e.preventDefault()
        setloading(true)
        let requestdata = {
            _id: id,
            deleted_at: "1"
        }
        axios.put(`${Base_Url}/video_sections`, requestdata, { headers }).then((res) => {

            if (res.data.error == 0) {
                setloading(false)
                toast.success("Data Deleted Successfully")
                handleget()

            }
        })
    }


    const handleVideoShow = (url) => {
        setCurrentVideo(url);
        setVideoShow(true);
    };
    return (

        <Sidebaar content={
            <>
                <ToastContainer />
                {loading && (
                    <div className="overlay">
                        <Bars
                            height="80"
                            width="80"
                            color="#051322"
                            ariaLabel="bars-loading"
                            visible={true}
                        />
                    </div>
                )}
                <Form onSubmit={(e) => handleSubmit(e)}>
                    <div className="row gy-3">
                        <TitleComp title="Add Video" />
                        <div className='col-md-4'>
                            <FormGroup>
                                <label htmlFor="">Name</label>
                                <input type="text" value={name} onChange={(e) => setname(e.target.value)} className='form-control' />
                            </FormGroup>
                        </div>
                        <div className='col-md-4'>
                            <FormGroup>
                                <label htmlFor="">Image</label>
                                <input type="file" ref={ImageInputRef} onChange={(e) => handlefile(e)} className='form-control' />
                            </FormGroup>
                        </div>
                        <div className='col-md-4'>
                            <FormGroup>
                                <label htmlFor="">Youtube Link</label>
                                <input type="text" value={youtube_link} onChange={(e) => setyoutube_link(e.target.value)} className='form-control' />
                            </FormGroup>
                        </div>
                        <div className='col-md-12'>
                            <FormGroup>
                                <label htmlFor="">Description</label>
                                <textarea name="" className='form-control' value={description} onChange={(e) => setdescription(e.target.value)} id=""></textarea>
                            </FormGroup>
                        </div>
                        <div className="col-md-12">
                            <button className="btn bg-dark mt-3 text-white">
                                Submit
                            </button>
                        </div>
                        <div className="col-md-12">
                            <Box sx={{ height: 500, width: "100%" }}>
                                <DataGrid
                                    //   rows={data} // Update this line
                                    rows={data}
                                    columns={columns}
                                    pageSize={5}
                                    getRowId={getRowId}
                                    initialState={{
                                        pagination: { paginationModel: { pageSize: 10 } },
                                    }}
                                    pageSizeOptions={[5, 10, 25]}
                                />
                            </Box>
                        </div>

                    </div>

                </Form>
                <Modal
                    size="lg"
                    show={videoshow}
                    className="productVideo"
                    onHide={handleVideoClose}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton className="p-0 border-0">
                        <button className='close-btn' onClick={handleVideoClose}><i class="fa-solid fa-xmark"></i></button>
                    </Modal.Header>
                    <Modal.Body>
                        <Iframe
                            url={currentVideo}
                            className="iframe"
                            display="block"
                            position="relative"
                            allow="fullscreen"
                            allowFullScreen
                        />
                    </Modal.Body>
                </Modal>
            </>


        } />
    )
}

export default Videosection
